import { UserDisciplineRecordDialogComponent } from './user-discipline-record-dialog/user-discipline-record-dialog.component';
import { DisciplineRecordService } from 'src/app/services/discipline-record.service';
import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { ApiPagination } from 'src/app/models/api/api-pagination.model';
import DisciplineRecord from 'src/app/models/discipline-record.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import {
  Input,
  inject,
  Component,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-user-discipline-records-data',
  templateUrl: './user-discipline-records-data.component.html',
})
export class UserDisciplineRecordsDataComponent implements OnChanges {
  @Input() startLoading: boolean = false;
  @Input() userId?: string;

  private baseComponentService = inject(BaseComponentService);
  private disciplineRecordService: DisciplineRecordService = inject(
    DisciplineRecordService
  );

  protected pagination: ApiPagination = new ApiPagination({ limit: 99 });
  protected loading: boolean = true;
  protected error?: ApiError;

  protected disciplineRecords: DisciplineRecord[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['startLoading'].currentValue &&
      !changes['startLoading'].previousValue
    ) {
      this.getData();
    }
  }

  private getData() {
    this.loading = true;
    this.error = undefined;
    this.disciplineRecordService
      .getDisciplineRecordsListing({
        page: this.pagination.page,
        limit: this.pagination.limit,
        userId: this.userId ?? 'ID-ERROR',
      })
      .subscribe({
        next: (response) => {
          this.pagination = response.pagination
            ? response.pagination
            : new ApiPagination({ limit: 99 });
          this.disciplineRecords = (response.data || []).map(
            (json) => new DisciplineRecord(json)
          );
        },
        error: (error) => {
          this.error = new ApiError(error);
          console.error('getDisciplineRecordsListing - ERROR:', this.error);
        },
      })
      .add(() => (this.loading = false));
  }

  protected newDisciplineRecord() {
    const size = '480px';
    this.baseComponentService.dialog
      .open(UserDisciplineRecordDialogComponent, {
        data: { userId: this.userId },
        maxWidth: size,
        minWidth: size,
        autoFocus: false,
        restoreFocus: false,
      })
      .afterClosed()
      .subscribe((dialogResult: boolean | DisciplineRecord) => {
        if (dialogResult) this.getData();
      });
  }

  protected deleteDisciplineRecord(id?: string | undefined) {
    if (!id) return;
    this.baseComponentService
      .confirmDeletion({
        message: 'Confermi di voler eliminare questo provvedimento?',
        details: "L'operazione non sarà reversibile",
        trueBtn: 'Sì, elimina',
        falseBtn: 'No, annulla',
        destructive: true,
      })
      .subscribe({
        next: (result) => {
          if (result === true)
            this.disciplineRecordService.deleteDisciplineRecord(id).subscribe({
              next: (_) => this.getData(),
              error: (error) => {
                console.error('deleteDisciplineRecord - ERROR:', error);
                this.baseComponentService
                  .showErrorDialog({ error: new ApiError(error) })
                  .subscribe();
              },
            });
        },
      });
  }
}
